<template>
  <div class="inputs">
    <el-select
      style="width: 100%"
      v-validate="inputValidate"
      :name="inputName"
      v-model="inputVal"
      size="small"
      clearable
      @clear="clear"
      ref="treeselect"
      placeholder="请选择"
      :disabled="!isEdit || !inputWriteable"
      :filterable="filterable"
      :filter-method="filterMethod"
      :multiple="multiple"
      @visible-change="changeValue1($event)"
      @change="selectChange"
    >
      <el-option
        v-show="false"
        v-for="item in tempoptions"
        :value="item.key"
        :label="item.name"
        :key="item.key"
      ></el-option>
      <el-option value :disabled="false">
        <el-tree
          ref="treeselectElTree"
          node-key="key"
          :data="options"
          :check-on-click-node="true"
          :highlight-current="true"
          :default-expand-all="true"
          :expand-on-click-node="true"
          :props="defaultProps"
          @check="handleNodeClick"
          @node-click="handleNodeClick"
          :filter-node-method="filterNode"
          :show-checkbox="multiple"
          @check-change="handleCheckChange"
        ></el-tree>
      </el-option>
    </el-select>
    <fe-field-tail
      :fieldName="inputName"
      :readonly="false"
      :inputValue="valueDesc"
      :tag-format-value="tagFormatValue"
    />
  </div>
</template>
<script>
import utils from "@/utils.js";
import ecoUtils from "@/eco-ui-util.js";
import req from "@/request.js";
import { mapState, mapActions } from "vuex";

export default {
  name: "eip-treeselect",
  props: [
    "validate",
    "value",
    "name",
    "permission",
    "multiple",
    "selectlist",
    "ganged",
    "filterable",
    "allowCreate",
    "styles",
    "configAttributes",
    "customQuery",
    "dickey"
  ],
  data() {
    return {
      config: {},
      isEdit: false,
      options: [],
      tempoptions: [],
      valueDesc: "",
      tagFormatValue: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      newValidate: null,
      curSubIndex: null,
      checkedNodes: []
    };
  },
  watch: {
    valueDesc: function(newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        this.tagFormatValue = newVal.split(",");
      }
    },
    options: {
      handler(newVal) {
        if (newVal) {
          this.$validator = this.$root.$validator;
        }
      },
      deep: true,
      immediate: true
    },
    inputVal: {
      handler(newVal) {
        if (newVal) {
          this.$root.$validator.errors.clear("custom-form");
          this.$validator.errors.clear("custom-form");
          const list = document.querySelectorAll("div");
          const list1 = document.querySelectorAll("input");
          if (list && list.length > 0) {
            list.forEach(ele => {
              const a = ele.getAttribute("aria-invalid");
              if (a === "true") {
                ele.setAttribute("aria-invalid", "false");
              }
            });
          }
          if (list1 && list1.length > 0) {
            list1.forEach(ele => {
              const a = ele.getAttribute("aria-invalid");
              if (a === "true") {
                ele.setAttribute("aria-invalid", "false");
              }
            });
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState({
      allDataDict: state => state.user.allDataDict
    }),
    inputVal: {
      get() {
        if (this.options && this.options.length > 0) {
          // this.$validator = this.$root.$validator;
          if (this.multiple) {
            if (this.value) {
              if (this.$refs.treeselectElTree) {
                let checkedNodes = this.$refs.treeselectElTree.getCheckedNodes();
                for (let data of checkedNodes) {
                  if (!this.value.split(",").includes(data.key)) {
                    this.$refs.treeselectElTree.setChecked(data, false);
                  }
                }
              }
              return this.value.split(",");
            } else {
              if (this.$refs.treeselectElTree) {
                let checkedNodes = this.$refs.treeselectElTree.getCheckedNodes();
                for (let data of checkedNodes) {
                  this.$refs.treeselectElTree.setChecked(data, false);
                }
              }
              return [];
            }
          } else if (this.value || this.value === 0) {
            return this.value + "";
          } else {
            return this.value;
          }
        } else {
          return "";
        }
      },
      set(val) {
        if (this.multiple) {
          if (this.value) {
            let arr = this.value.split(",");
            this.$emit("input", arr.join(","));
          } else if (val) {
            this.$emit("input", val.join(","));
          }
        } else {
          if (this.value) {
            this.$emit("input", this.value);
          } else if (val) {
            this.$emit("input", val);
          }
        }
      }
    },
    inputWriteable: function() {
      return utils.getWriteable(this.permission);
    },
    inputValidate: function() {
      return utils.addRequiredOrNot(this.permission, this.validate, this);
    },
    inputName: function() {
      let labeldesc = "";
      if (
        this.$slots &&
        this.$slots.labeldesc &&
        this.$slots.labeldesc[0].children &&
        this.$slots.labeldesc[0].children[0].text
      ) {
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName() + "-" + labeldesc;
      } else {
        return this.name ? this.name : utils.getName();
      }
    }
  },
  mounted() {
    if (this.configAttributes) {
      if (this.configAttributes.isInputEdit) {
        this.isEdit = !this.configAttributes.isInputEdit;
      } else {
        this.isEdit = true;
      }
    } else {
      this.isEdit = true;
    }
  },
  created() {
    this.options = this.selectlist ? this.selectlist : [];
    if (this.dickey) {
      const this_ = this;
      if (this_.$store.state.menu.dataDic[this_.dickey]) {
        this_.options = this_.$store.state.menu.dataDic[this_.dickey];
        this_.search(false, "");
      } else {
        if(this_.allDataDict && this_.allDataDict.length> 0) {
          this_.allDataDict.forEach(e=> {
            if(e.key == this_.dickey) {
              this_.options = e.children
            this_.search(false, "");

            }
          })
        }
        // this_.$store
        //   .dispatch("menu/getByTypeKeyForComBo", this_.dickey)
        //   .then(res => {
        //     this_.options = res;
        //   });
        if (this.options) {
          // this.$validator = this.$root.$validator;
        }
      }
    }
  },
  methods: {
    changeValue1(callback) {
      if (!callback) {
        setTimeout(() => {
          this.$refs.treeselectElTree.filter();
        }, 1000);
      } else {
        if (this.options && this.options.length > 0) {
          const arr = [];
          this.options.forEach((v, i) => {
            if (v.deleted != 1) {
              arr.push(v);
            }
            if (i == this.options.length - 1) {
              this.options = arr;
            }
          });
        }
      }
    },
    selectChange(val) {
      let str = "";
      if (val.length > 0) {
        val.forEach(item => {
          str += item + ",";
        });
      }
      str = str.substring(0, str.length - 1);
      this.value = str;
    },
    clear() {
      this.checkedNodes = [];
      if (this.multiple) {
        this.tempoptions = [];
        this.$nextTick(function() {
          this.$refs.treeselectElTree.setCheckedKeys([], true);
        });
      } else {
        this.$emit("input", "");
      }
    },
    clickNative: function() {
      //动态传入
      if (this.options.length < 1) {
        const this_ = this
        if(this_.allDataDict && this_.allDataDict.length> 0) {
          this_.allDataDict.forEach(e=> {
            if(e.key == this_.dickey) {
              this_.options = e.children
            this_.search(false, "");

            }
          })
        }
        // this.$store
        //   .dispatch("menu/getByTypeKeyForComBo", this.dickey)
        //   .then(res => {
        //     this.options = res;
        //     this.search();
        //   });
      }
    },
    selectBlur: function(val) {
      this.$refs.treeselectElTree.filter();
    },
    handleCheckChange(data) {
      if (this.multiple) {
        let checkedNodes = this.$refs.treeselectElTree.getCheckedNodes();
        let modelValue = [];
        this.tempoptions = checkedNodes;
        for (let data of checkedNodes) {
          modelValue.push(data.key);
        }
        this.$emit("input", modelValue.join(","));
      }
    },
    handleNodeClick(data) {
      this.$refs.treeselectElTree.setChecked(data, true);
      if (!this.multiple) {
        if (data.isParent != "true") {
          this.$emit("input", data.key);
          // this.inputVal = data.key;
          this.$refs.treeselect.blur();
        }
      } else if (this.multiple) {
        let checkedNode = this.$refs.treeselectElTree.getCheckedNodes();
        let modelValue = [];
        this.tempoptions = checkedNode;
        if (this.checkedNodes.hasOwnProperty(data.key)) {
          delete this.checkedNodes[data.key];
          for (let val of checkedNode) {
            if (val.key != data.key) {
              modelValue.push(val.key);
            }
          }
          this.$emit("input", modelValue.join(","));
        } else {
          let keys = data.key;
          this.checkedNodes[keys] = keys;
          for (let val of checkedNode) {
            modelValue.push(val.key);
          }
          this.$emit("input", modelValue.join(","));
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    filterMethod(query) {
      this.$refs.treeselectElTree.filter(query);
    },
    remoteMethod: function(val) {
      if (val) {
        this.search(false, val);
      } else {
        this.param = "";
        this.search();
      }
    },
    handleCurrentChange: function() {
      this.search();
    },
    search() {
      //tree数组转list
      this.addSelectList(this.options);
      if (
        this.inputVal &&
        this.inputVal.constructor === Array &&
        this.inputVal.length > 0
      ) {
        for (let j = 0; j < this.inputVal.length; j++) {
          this.findDesc(this.options, this.inputVal[j]);
        }
        //默认选中树节点
        this.$refs.treeselectElTree.setCheckedKeys(this.inputVal);
      } else {
        this.findDesc(this.options, this.inputVal);
      }
      if (this.valueDesc !== "") {
        this.valueDesc = this.valueDesc.substring(0, this.valueDesc.length - 1);
      }
    },
    findDesc(list, key) {
      this.valueDesc = "";
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].key === key) {
            this.valueDesc += list[i].name + ",";
            return;
          }
          if (list[i].children && list[i].children.length > 0) {
            this.findDesc(list[i].children, key);
          }
        }
      }
    },
    addSelectList(list) {
      if (list && list.length > 0) {
        list.forEach(l => {
          this.tempoptions.push(l);
          if (l.children) {
            this.addSelectList(l.children);
          }
        });
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
div[aria-invalid='true'] >>> .el-input__inner, div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}

.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
  background-color: #fff;
}

.el-select-dropdown__item {
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  height: 100%;
  line-height: 34px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}

li.el-select-dropdown__item.selected {
  font-weight: normal;
}
</style>
